import React from "react";
import { useState } from "react";
import { useAsyncDebounce } from "react-table";
// Define a default UI for filtering
export function GlobalFilter(_a) {
    var globalFilter = _a.globalFilter, setGlobalFilter = _a.setGlobalFilter, t = _a.t;
    var _b = useState(globalFilter), value = _b[0], setValue = _b[1];
    var onChange = useAsyncDebounce(function (value) {
        setGlobalFilter(value || undefined);
    }, 200);
    return (React.createElement("form", { className: "form-horizontal" },
        React.createElement("div", { className: "form-group" },
            React.createElement("div", { className: "col-1 col-lg-2 col-sm-15" },
                React.createElement("label", { className: "form-label", htmlFor: "input-example-1" }, "Name")),
            React.createElement("div", { className: "col-11 col-lg-10 col-sm-8" },
                React.createElement("input", { className: "form-input", type: "text", id: "input-example-1", placeholder: t("main.search_placeholder"), value: value || "", onChange: function (e) {
                        setValue(e.target.value);
                        onChange(e.target.value);
                    } })))));
}
